import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import StaffDashboardSectionCustomComponent from '../components/custom-components/StaffDashboardSectionCustomComponent';

const meta = {
  title: '',
  meta: [],
  link: [],
  style: [],
  script: [],
};

export default function StaffDashboard() {
  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet {...meta}></Helmet>
      </HelmetProvider>
      <StaffDashboardSectionCustomComponent />
    </React.Fragment>
  );
}

